<div class="address-book">
  <div class="main-content" [@addressAnimation]="getPage(addressOutlet)">
    <router-outlet #addressOutlet="outlet"></router-outlet>
  </div>
</div>
